import { Box, Text } from '@mantine/core';
import { Button } from 'src/components';
import { useSharepoint } from 'src/data-capture/file-management/drop-zone/useSharepoint';

export type PickedItem = {
  id: string;
  parentReference?: { driveId: string };
  name?: string;
  downloadUrl?: string;
  size?: number;
  createdDateTime?: string;
  [key: string]: unknown;
};

type OneDriveButtonProps = {
  onPickedItems: (items: PickedItem[]) => void;
  onAccountChange: (account: { name?: string; username?: string } | null) => void;
  switchAccountRequested: boolean;
  onSwitchAccountHandled: () => void;
  fileExtensions?: string[];
};

export default function SharePointButton({
  onPickedItems,
  onAccountChange,
  switchAccountRequested,
  onSwitchAccountHandled,
  fileExtensions,
}: OneDriveButtonProps) {
  const {
    error,
    isAuthenticated,
    handleLoginPress,
    isLoading,
    handleOpenPicker,
    baseUrl,
    isLoadingBaseUrl,
  } = useSharepoint({
    onPickedItems,
    onAccountChange,
    switchAccountRequested,
    onSwitchAccountHandled,
    fileExtensions,
  });

  return (
    <Box>
      {error && (
        <Box p="md" mb="md" bg="red.0" style={{ borderRadius: 8 }}>
          <Text fw={600} c="red">
            Error:
          </Text>
          <Text c="red">{error}</Text>
        </Box>
      )}
      {!isAuthenticated ? (
        <Button
          variant={'primary'}
          fullWidth
          onClick={() => handleLoginPress()}
          loading={isLoading}
        >
          Connect SharePoint account
        </Button>
      ) : (
        <Button
          variant={'primary'}
          fullWidth
          onClick={handleOpenPicker}
          disabled={!baseUrl && !isLoadingBaseUrl}
          loading={isLoadingBaseUrl}
        >
          {isLoadingBaseUrl ? 'Connecting...' : 'Pick files'}
        </Button>
      )}
    </Box>
  );
}
